import React, {Fragment, useState, useEffect} from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

import {ToastContainer, toast} from "react-toastify";

import DataTable from "react-data-table-component";
import {gruppi_relatori} from '../../../api/speaker_groups'
import {gruppi} from '../../../api/groups'
import speakersGroupUtil from './gruppirelatoriutils';


const GruppiRelatori = (props) => {
    const columns = [
      {
        name: "Nome",
        selector: "name",
        sortable: true,
        center: true,
        className: "default-text mb-0 f-w-700 f-18",
        style: 'color: var(--primary-color);font-weight: 700;font-size: 14px;',
        width: '15%'

      },

      {
        name: "Azioni",
        selector: "id",
        sortable: true,
        center: true,
        format: (row) => {
          return (
            <>
                    <Button color="warning"
                        className="btn btn-pill btn-sm btn-air-warning btn-warning"
                        onClick={loadFormEdit.bind(this, row)}>Gestisci</Button>
              &nbsp;
              <Button color="primary"
                      className="btn btn-pill btn-sm btn-air-danger  btn-danger"
                      onClick={deletegroup.bind(this, row.id)}>Elimina</Button>
            </>
          )
        },
      },
    ];

  const [id, setId] = useState();
  const [last10gruppi, setLast10Gruppi] = useState([]);
  const [groupid, setGroupId] = useState('');
  const [name, setName] = useState('');
  const [isloading, setIsLoading] = useState(false);
  const [listagruppi, setListaGruppi] = useState([]);
  const [listagruppiFiltro, setListaGruppiFiltro] = useState([]);
  const [listaGruppiRelatori, setListaGruppiRelatori] = useState([]);


  useEffect(async () => {
    await load();
  }, []);

  const load = async () => {
    try {
      const listagruppirelatori = await gruppi_relatori.methods.loadGruppiRelatori();
      console.log('listaGruppiRelatori: ', listagruppirelatori);
      // let listagruppirelatori = listagruppirelatoriraw.sort(function (a, b) {
      //   // Turn your strings into dates, and then subtract them
      //   // to get a value that is either negative, positive, or zero.
      //   return new Date(b.timestamp) - new Date(a.timestamp);
      // })
      listagruppirelatori.length = (listagruppirelatori.length > 10 ? 10 : listagruppirelatori.length);
      console.log(listagruppirelatori)
      setLast10Gruppi(listagruppirelatori);
      setListaGruppiRelatori(listagruppirelatori);
      setListaGruppiFiltro(listagruppirelatori);
    } catch (e) {
      toast.error('Impossibile recuperare i gruppi creati')
      setLast10Gruppi([]);

    }

    try {
      const list = await gruppi.methods.loadGruppi();
      setListaGruppi(list);
    } catch (e) {
      toast.error('Impossibile recuperare i gruppi')
    } 

  }

  const deletegroup = async (id) => {
    try{
      if(await gruppi_relatori.methods.deleteGruppoRelatori(id)){
        setTimeout(() => {
          toast.success(
            'Gruppo cancellato'
          );
        }, 300);
        load();
      }else{
        toast.error(
          'Il gruppo ha sessioni o utenti associati'
        );
      }
      
    }catch(e){
      toast.error(
        'Il gruppo ha sessioni o utenti associati'
      );
      console.log(e);
    }
    
  }


  const clearForm = () => {
    setId();
    setName('');
    setGroupId();
    document.getElementById('groupselect').value='';
  }

  const loadFormEdit = (row) => {
    setId(row.id);
    setName(row.name);
    setGroupId(row.group.id);
    document.getElementById('groupselect').value=row.group.id;
  }

  const submit = async () => {

    setIsLoading(true)
    const inputobject = 
    {
      "name": name,
      "group": 
        {
          "id": groupid
        }
    }


    if(id) inputobject.id=(id);
    const validateresult = speakersGroupUtil.methods.validateGruppoRelatori(inputobject);
    if (validateresult.length) {
      console.log(2);
      //TODO gestire validate field su campo input
      validateresult.forEach((e) => {
          console.log(e);
          toast.error(
            e.field + ':' + e.error
          );
        }
      );
      setIsLoading(false)
      return;
    }
    try {
      const result = await gruppi_relatori.methods.saveGruppoRelatori(inputobject);
      toast.success("Gruppo salvato...");
      clearForm();
      await load();
    } catch (e) {
      toast.error("Qualcosa è andato storto...");
    } finally {
      setIsLoading(false)
    }
  }


  return (
    <Fragment>
      <Breadcrumb parent="Gruppi" title="Gestione" subtitle="Gruppi relatori"/>
      <Container fluid={true}>
        <Row>

          <Col xs="12">
            <Card className="card-absolute">
              <CardHeader className="bg-primary">
                <h5>Dati Gruppo Relatori {name}</h5>
              </CardHeader>
              <CardBody className="add-post">
                <Form id="savesession" className="row needs-validation">
                  <Col sm="12">
                    <Row>
                      <Col xs="12" sm="6" md="6" xl="6" lg="6">
                        <FormGroup>
                          <Label for="validationCustom01">Nome:</Label>
                          <Input
                            className="form-control"
                            id="input_nome_gruppo"
                            type="text"
                            placeholder=""
                            required={true}
                            value={name}
                            onChange={(e) => {
                              setName(e.target.value)
                            }}
                          />
                          <div className="valid-feedback">Ok!</div>
                        </FormGroup>

                      </Col>

                    </Row>
                    <Row>
                      <Col xs="12" sm="6" md="6" xl="6" lg="6">
                        <FormGroup>
                          <Label for="validationCustom01">Gruppo:</Label>
                          <select id="groupselect" className="form-control btn-pill" onChange={(e) => {
                            setGroupId(e.target.value)
                          }} size="1">
                            <option value=''>Seleziona</option>
                            {
                              Array.isArray(listagruppi) ? listagruppi.map((data, i) => {
                                return (
                                  <option value={data.id}>{data.name}</option>
                                );
                              }) : <option value={1}>{'admin'}</option>
                            }
                          </select>
                        </FormGroup>

                      </Col>
                    </Row>
                  </Col>
                </Form>
                <Row>
                  &nbsp;
                </Row>
                <div className="btn-showcase" style={{textAlign: 'right'}}>
                  <Button disabled={isloading} id="buttonsubmit" color="primary btn-pill" type="button"
                          onClick={submit}>
                    Salva
                  </Button>
                  <Button color="danger btn-pill" type="reset" onClick={clearForm}>
                    Annulla
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>

        </Row>
        <Row>
          <Col xs="12" sm="12">
            <Card className="card-absolute">
              <CardHeader className="bg-secondary">
                <h5>Lista Gruppi Relatori</h5>
              </CardHeader>
              <CardBody className="add-post">
                <div className="datatable-filter">
                  <div className="faq-form">
                    <Input
                      className="form-control "
                      type="text"
                      placeholder="Cerca gruppo relatori..."
                       
                      onChange={(e) => {

                        setListaGruppiFiltro(listaGruppiRelatori.filter(function (el) {
                            return el.name.toLowerCase().includes(e.target.value.toLowerCase());
                          })
                        );

                        console.log(e.target.value)
                      }}
                      onKeyPress={event => {
                        if (event.key === 'Enter') {
                          console.log(event.target.value);
                        }
                      }}
                    />
                  
                  </div>
                </div>  
                <DataTable
                  columns={columns}
                  data={listagruppiFiltro}
                  striped={true}
                  center={true}
                  className="table-xs table table-styling"
                  style={{
                    marginTop: "0px",
                    maxWidth: "100%",
                    overflow: 'auto',
                    width: '100%',
                    position: 'relative',
                    top: '-55px'
                  }}
                  pagination={true}
                  paginationPerPage={10}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ToastContainer/>
      </Container>
    </Fragment>
  );
};


export default GruppiRelatori;
